// src/store/common/cart-list.js
import axiosInstance from "../../axios";
import {toast} from "react-toastify";

// Action Types
export const CART_LIST_REQUEST = 'CART_LIST_REQUEST';
export const CART_LIST_SUCCESS = 'CART_LIST_SUCCESS';
export const CART_LIST_FAILURE = 'CART_LIST_FAILURE';
export const CART_REMOVE_REQUEST = 'CART_REMOVE_REQUEST';
export const CART_REMOVE_SUCCESS = 'CART_REMOVE_SUCCESS';
export const CART_REMOVE_FAILURE = 'CART_REMOVE_FAILURE';
export const CART_UPDATE_QUANTITY = 'CART_UPDATE_QUANTITY';
export const CART_CHECKOUT="CART_CHECKOUT";

// Action Creators
export const cartListRequest = () => ({
    type: CART_LIST_REQUEST,
});

export const cartListSuccess = (carts) => ({
    type: CART_LIST_SUCCESS,
    payload: carts,
});

export const cartListFailure = (error) => ({
    type: CART_LIST_FAILURE,
    payload: error,
});

export const cartRemoveRequest = () => ({
    type: CART_REMOVE_REQUEST,
});

export const cartRemoveSuccess = (cartId) => ({
    type: CART_REMOVE_SUCCESS,
    payload: cartId,
});

;

export const cartRemoveFailure = (error) => ({
    type: CART_REMOVE_FAILURE,
    payload: error,
});

export const cartUpdateQuantity = (cartId, quantity) => ({
    type: CART_UPDATE_QUANTITY,
    payload: {
        cartId,
        quantity
    },
});

// Thunk Actions
export const fetchCartList = () => async (dispatch) => {
    try {
        dispatch(cartListRequest());
        const response = await axiosInstance.get('cart');
        const cartItems = response.data.data;
        dispatch(cartListSuccess(cartItems));
    } catch (error) {
        console.log(error);
        let errorMessage = 'Failed to fetch cart items';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(cartListFailure(errorMessage));
    }
};

export const addToCart = (object) => async (dispatch) => {
    try {
        const res = await axiosInstance.post('cart/add',object);
        if (res.data.code === 1) {
            dispatch(fetchCartList())
            return {success: true, message: res.data.message};
        } else {

            return {success: false, message: res.data.message};
        }
    } catch (error) {
        let errorMessage = 'Failed to fetch cart items';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(cartListFailure(errorMessage));
        return {success: false, message: errorMessage};
    }
};

export const checkOutCart = (remarks) => async (dispatch) => {
    try {
        const object={
            remarks:remarks
        }
        const res = await axiosInstance.post(`cart/checkout`,object);

        if (res.data.code === 1) {
            return {success: true, message: res.data.message};
        } else {
            return {success: false, message: res.data.message};
        }
    } catch (error) {
        let errorMessage = 'Failed to place order';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(cartListFailure(errorMessage));
        return {success: false, message: errorMessage};
    }
};


export const removeFromCart = (cartId) => async (dispatch) => {
    try {
        dispatch(cartRemoveRequest());
        await axiosInstance.get(`cart/delete/${cartId}`);
        dispatch(cartRemoveSuccess(cartId));
    } catch (error) {
        console.log(error);
        let errorMessage = 'Failed to remove item from cart';
        if (error.message) {
            errorMessage = error.message;
        }
        dispatch(cartRemoveFailure(errorMessage));
    }
};

export const updateCartQuantity = (cartId, quantity) => async (dispatch) => {
    try {
        const result=await axiosInstance.post(`cart/update/${cartId}`, { quantity });
        console.log(result)
        dispatch(cartUpdateQuantity(cartId, quantity));
    } catch (error) {
        console.log(error);
        // If the quantity update fails, refresh the cart list
        dispatch(fetchCartList());
    }
};

// Initial State
const initialState = {
    loading: false,
    items: [],
    error: null,
    removingFromCart: false
};

// Reducer
const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case CART_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CART_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.payload,
                error: null
            };

        case CART_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case CART_REMOVE_REQUEST:
            return {
                ...state,
                removingFromCart: true,
                error: null
            };

        case CART_REMOVE_SUCCESS:
            return {
                ...state,
                removingFromCart: false,
                items: state.items.filter(cart => cart.id !== action.payload),
                error: null
            };

        case CART_REMOVE_FAILURE:
            return {
                ...state,
                removingFromCart: false,
                error: action.payload
            };

        case CART_UPDATE_QUANTITY:
            return {
                ...state,
                items: state.items.map(cart =>
                    cart.id === action.payload.cartId
                        ? { ...cart, quantity: action.payload.quantity }
                        : cart
                )
            };

        default:
            return state;
    }
};

export default cartReducer;